import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { buildEndpointWithQueryParams } from 'features/command-center/utils';
import startCase from 'lodash/startCase';
import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';
import { convertMinutesToSeconds, roundDecimals } from 'UI/utils';

import { METRICS } from './DailyPerformance.constants';

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    recruiterName: {
      empNo: item.empNo,
      name: item?.recruiterName
    },
    managerName: {
      managerEmpNo: item.managerEmpNo,
      team: item?.managerName
    },
    callsTime: item?.callsTime ? convertMinutesToSeconds(item?.callsTime) : 0,
    hireDate: item?.hireDate && moment(item?.hireDate).format(DateFormats.SimpleDate),
    lastPlacementDate:
      item?.lastPlacementDate && moment(item?.lastPlacementDate).format(DateFormats.SimpleDate),
    lastFeedbackActivityType:
      item?.lastFeedbackActivityType && startCase(item?.lastFeedbackActivityType),
    avgFeePercentage: item?.avgFeePercentage && roundDecimals(item?.avgFeePercentage, 2)
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};

export const getDownloadFileName = selectedDate => {
  const fileDate = selectedDate ?? moment.utc().local().format(DateFormats.QueryShortFormat);

  return `daily-performance-report-${fileDate}-${Date.now()}`;
};

export const getDownloadEndpoint = ({ excludedMetrics, queryParams }) =>
  buildEndpointWithQueryParams({
    baseEndpoint: `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.downloadProductivityRecruiterPerformance}`,
    queryParams: queryParams.params,
    metrics: METRICS.filter(metric => !excludedMetrics.includes(metric)).join(',')
  });
